import { Grid, Paper, Typography } from '@mui/material';

// Simple placeholder – can be wired to real stats endpoints later
const StatCard = ({ label, value }: { label: string; value: string | number }) => (
  <Paper sx={{ p: 3 }}>
    <Typography variant="subtitle2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h5">{value}</Typography>
  </Paper>
);

export const DashboardPage = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <StatCard label="Items" value="—" />
      </Grid>
      <Grid item xs={12} sm={4}>
        <StatCard label="Categories" value="—" />
      </Grid>
      <Grid item xs={12} sm={4}>
        <StatCard label="Messages" value="—" />
      </Grid>
    </Grid>
  );
};

